// CommentsModal.jsx

import Modal from "../Modal/Modal";
import stylez from "./Comments.module.css";

const CommentsModal = ({ show, setShow, comments }) => {
    const reversed= [...comments].reverse();
    return (
        <Modal show={show} setShow={setShow}>
            <div className={stylez.outerContainer}>
            <h2 className={stylez.title}>Comments:</h2>    
            <div className={stylez.container}>
                <div className={stylez.commentContainer}>
                {reversed.map((comment, index) => (
                <div className={stylez.commentBox} key={index}>
                    {comment.comment.split('\n').map((line, i) => (
                         <p key={i}>{line}</p>
                          ))}
                          <p className={stylez.commentDate}>{new Date(comment.date).toString()}</p>
                </div>
                ))}
                </div>  
            </div>
            <button className={stylez.closeButton} onClick={() => setShow(false)}>
                    Close
                </button>
            </div>
        </Modal>
    );
};

export default CommentsModal;
